import fetch from "../utils/fetch";
import requestTokenHeader from "./middleware/request-token-header";
import debugHeader from "./middleware/debug-header";
import retry from "./middleware/retry";
import sessionStorage from "../utils/session-storage";

const fetchWithRequestToken = retry(/401/)(
  debugHeader(requestTokenHeader(fetch))
);

const cacheKey = "pc-session";

let memo;

export const clearCache = () => {
  sessionStorage.removeItem(cacheKey);
  memo = undefined;
};

const session = async () => {
  if (memo) {
    return memo;
  }

  if (sessionStorage.getItem(cacheKey)) {
    memo = Promise.resolve(sessionStorage.getItem(cacheKey));
  } else {
    memo = fetchWithRequestToken(
      "https://apix.purecars.com/trade/api/v1/session",
      { method: "POST" }
    )
      .then(resp => resp.text())
      .then(session => {
        sessionStorage.setItem(cacheKey, session);
        return session;
      });
  }
  return memo;
};

export default session;
